import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'server';
import { SyncGithubUserView, SyncGithubDepartmentView } from './types';
import { AxiosResponse } from 'axios';
import {
  syncGithubUserModel,
  IsyncGithubUserModel,
  syncGithubDepartmentModel,
  IsyncGithubDepartmentModel,
  ISelectedUserModel,
  IOrganisationModel,
} from './models/githubtable.model';

const { model, array, maybeNull, reference } = types;
export const GithubStore = model(' GithubStore', {
  syncGithubusers: array(syncGithubUserModel),
  syncGithubdepartment: array(syncGithubDepartmentModel),
  clickedUser: maybeNull(reference(syncGithubUserModel)),
  clickedDepartment: maybeNull(reference(syncGithubDepartmentModel)),
})
  .views((self) => ({
    get allsyncUsersView(): SyncGithubUserView[] {
      const allsyncUsersView: SyncGithubUserView[] = [];
      for (let i = 0; i < self.syncGithubusers.length; i++) {
        allsyncUsersView.push({
          ...self.syncGithubusers[i],
          id: i,
        });
      }
      return allsyncUsersView;
    },
    get allsyncDepartmentsView(): SyncGithubDepartmentView[] {
      const allsyncDepartmentsView: SyncGithubDepartmentView[] = [];
      for (let i = 0; i < self.syncGithubdepartment.length; i++) {
        allsyncDepartmentsView.push({ ...self.syncGithubdepartment[i], id: i });
      }
      return allsyncDepartmentsView;
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeUsers({ data }: AxiosResponse): IsyncGithubUserModel[] {
      self.syncGithubusers.replace(data?.users);
      return self.syncGithubusers;
    },
    normalizeDepartment({ data }: AxiosResponse): IsyncGithubDepartmentModel[] {
      self.syncGithubdepartment.replace(data.departments);
      return self.syncGithubdepartment;
    },
    clearSelected(): void {
      self.clickedUser = null;
      self.clickedDepartment = null;
    },
  }))

  .actions((self) => ({
    syncUserGitHub: flow(function* (organisation) {
      let org = organisation;
      if (!org) {
        const localOrg = localStorage.getItem('organisation');
        if (localOrg) {
          org = localOrg;
        }
      }
      const result = yield axios
        .get<IsyncGithubUserModel[]>(`apps/github/users/${org}`)
        .then(self.normalizeUsers)
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }),

    getOrganisation: flow(function* () {
      const result = yield axios
        .get(`apps/github/organization`)
        .then((res) => {
          localStorage.setItem('organisation', res.data.organisation);
          return res.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    syncDepartmentGitHub: flow(function* () {
      const result = yield axios
        .get<IsyncGithubDepartmentModel[]>(`apps/github/departments`)
        .then(self.normalizeDepartment)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    reSyncUser: flow(function* () {
      const result = yield axios
        .get<IsyncGithubUserModel[]>(`admin/app/github/master-sync/user`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    reSyncSingleUser: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncGithubUserModel[]>(`apps/github/sync/user`, data)
        .then(self.clearSelected)
        .catch((error) => {
          const errorMessage = error.response?.data?.message || 'An unknown error occurred';
          throw new Error(errorMessage);
        });
      return result;
    }),
    Organisation: flow(function* (data: any) {
      const result = yield axios
        .post<IOrganisationModel[]>(`admin/app/github/organisation`, data)
        .then(self.clearSelected)
        .catch((error) => {
          const errorMessage = error.response?.data?.message || 'An unknown error occurred';
          throw new Error(errorMessage);
        });
      return result;
    }),
    reSyncSingleDepartment: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncGithubDepartmentModel[]>(`admin/app/github/sync/department-from-github`, data)
        .then(self.clearSelected)
        .catch((error) => {
          const errorMessage = error.response?.data?.message || 'An unknown error occurred';
          throw new Error(errorMessage);
        });
      return result;
    }),

    SelectedUser: flow(function* (data: any) {
      const result = yield axios
        .post<ISelectedUserModel[]>(`admin/app/github/sync/multiple-user-from-github`, data)
        .then(self.clearSelected)
        .catch((error) => {
          const errorMessage = error.response?.data?.message || 'An unknown error occurred';
          throw new Error(errorMessage);
        });
      return result;
    }),
  }));

export type IGithubStore = Instance<typeof GithubStore>;
